export const profileSettings = {
  title: 'Personal profile.',
  subtitle: 'To calculate the most accurate CO₂e footprint, here are 3 short questions.',
  text: 'Just pick the answer that most closely matches your situation; you can always adjust it later.',
  startButton: 'Get started',
  submitButton: 'See your footprint',
};
